import React, { Component } from "react";
import { Button, InputGroup, FormGroup, Card, Elevation } from "@blueprintjs/core";
import { BASE_API } from "../utils/constants";

class SignupPage extends Component {
    state = {
        email: "",
        password: "",
        organization: "",
        message: null,
        orgValid: true
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "organization") {
            const valid = /^[a-zA-Z0-9 \-_]*$/.test(value);
            this.setState({ orgValid: valid });
        }

        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { email, password, organization, orgValid } = this.state;

        if (!orgValid) {
            this.setState({ message: "Numele organizației conține caractere invalide." });
            return;
        }

        try {
            const res = await fetch(`${BASE_API}/api/auth/signup`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password, organization }),
            });

            const data = await res.json();
            this.setState({
                message: res.ok ? "Contul a fost trimis pentru aprobare." : data.error || "Eroare la înregistrare.",
            });
        } catch {
            this.setState({ message: "Eroare de rețea." });
        }
    };

    render() {
        const { email, password, organization, message, orgValid } = this.state;

        return (
            <div style={{ maxWidth: 400, margin: "2rem auto" }}>
                <Card elevation={Elevation.TWO}>
                    <h3>Înregistrare cont antrenor</h3>
                    <form onSubmit={this.handleSubmit}>
                        <FormGroup label="Email">
                            <InputGroup
                                name="email"
                                type="email"
                                value={email}
                                onChange={this.handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup label="Parolă">
                            <InputGroup
                                name="password"
                                type="password"
                                value={password}
                                onChange={this.handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup label="Organizație">
                            <InputGroup
                                name="organization"
                                type="text"
                                value={organization}
                                onChange={this.handleChange}
                                required
                                intent={orgValid ? "none" : "danger"}
                            />
                            {!orgValid && (
                                <span style={{ color: "red", fontSize: "0.8rem" }}>
                                    Doar litere, cifre, `-` și `_` sunt permise.
                                </span>
                            )}
                        </FormGroup>
                        <Button intent="primary" type="submit" fill>
                            Creează cont
                        </Button>
                    </form>
                    {message && <p style={{ marginTop: 16 }}>{message}</p>}
                </Card>
            </div>
        );
    }
}

export default SignupPage;
